import { useMemo } from 'react';

export const useArrowClass = (position) =>
  useMemo(() => {
    if (!position) {
      return 'down';
    }

    if (position.startsWith('bottom')) {
      return 'up';
    }

    if (position.startsWith('right')) {
      return 'left';
    }

    if (position.startsWith('left')) {
      return 'right';
    }

    return 'down';
  }, [position]);
